import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";
import React from "react";
import { BooleanInput, ReferenceInput, required, SelectInput } from "react-admin";
import { useWatch, useFormContext } from "react-hook-form";

const GraduatedStudents = ({ handleParamChange }) => {
  const { setValue } = useFormContext();
  const structuralUnitId = useWatch({ name: "structuralUnitId" });

  return (
    <>
      <ReferenceInput
        reference={administrationRequests.getStructuralUnitsSelect()}
        source="structuralUnitId"
        filter={{ filterByUser: true }}
      >
        <AutoPickSelectInput
          source="structuralUnitId"
          label="Факултет"
          validate={required()}
          emptyText={false}
          onChange={() => setValue("specialityId", null)}
          onValueChange={v => handleParamChange("structuralUnitId", v)}
        />
      </ReferenceInput>
      {structuralUnitId && (
        <ReferenceInput
          source="specialityId"
          reference={administrationRequests.getSpecialitiesSelect()}
          filter={{ structuralUnitId }}
        >
          <AutoPickSelectInput
            source="specialityId"
            label="Специалност"
            optionText="name"
            optionValue="id"
            validate={[required()]}
            emptyText={false}
            onValueChange={v => handleParamChange("specialityId", v)}
          />
        </ReferenceInput>
      )}
      <ReferenceInput
        source="instructionLanguageId"
        reference={administrationRequests.getInstructionLanguagesSelect()}
      >
        <SelectInput
          label="Език на обучение"
          validate={required()}
          emptyText={false}
          onChange={e => handleParamChange("instructionLanguageId", e.target.value)}
        />
      </ReferenceInput>
      <ReferenceInput
        source="academicYearId"
        reference={studentRequests.getAcademicYearsSelect()}
      >
        <SelectInput
          label="Учебна година"
          validate={required()}
          emptyText={false}
          onChange={e => handleParamChange("academicYearId", e.target.value)}
        />
      </ReferenceInput>
      <BooleanInput
        source="includeStateExams"
        label="Включва държавни изпити"
        onChange={e => handleParamChange("includeStateExams", e.target.checked)}
      />
    </>
  );
};

export default GraduatedStudents;
